<template>
	<el-popover :title="items.project_type == 'service' ?'洗护美容结算':'商品结算'" placement="left" trigger="click" v-model="visible"  :disabled="use_lock" width="500" height="400" @hide="hidPopover" >
		<!-- 商品信息开始 -->
		<div class="goods_info" >
			<span class="goods_name">
				{{items.project_name}}
			</span>
			<span class="goods_class">
				<el-tag v-for="(skuRow,index) in items.skuList" :key="index" size="mini">{{skuRow}}</el-tag>
			</span>
			<span class="goods_price">
				￥{{items.project_original_price}} x {{quantity}}
			</span>
			<span class="goods_total_price">
				{{items.project_subtotal_amount}}
			</span>
		</div>
		<!-- 商品信息结束 -->
		<!-- 选择优惠开始 -->
		<div class="selWarpper" >
			<!-- 项目单价大于0 才需要操作优惠 -->
			<template v-if="items.project_original_price > 0">
				<div class="goodCoupon" v-if="app_member_price_discount_status && is_gifts != 1">
					<span class="coupon1">会员价</span>
					<span>
						<el-select v-if="app_member_price_discount_status" v-model="use_member_price" placeholder="选择会员折扣" style="width:100%" size="small">
							<el-option label="不使用" value="0">不使用</el-option>
							<el-option :label="items.app_member_price.discount_name" value='1'>{{items.app_member_price.group_name}}{{items.app_member_price.discount_name}}</el-option>
						</el-select>
					</span>
				</div>
				<div class="goodCoupon" v-if="items.project_type == 'service'&& is_gifts != 1">
					<span class="coupon1">服务卡</span>
					<span>
						<el-select v-model="use_user_card" placeholder="选择服务卡" style="width:100%" @change="cardChange">
							<el-option label="不使用" value="0">不使用</el-option>
							<el-option v-for="item in items.user_card_service" :key="item.user_card_id" :label="item.card_name" :value="item.user_card_id">
							</el-option>
						</el-select>
					</span>
				</div>
				<!-- 商品优惠 -->
				<div class="goodCoupon" v-if="use_user_card == 0">
					<span class="coupon1">商品优惠</span>
					<span v-if="is_gifts == 1">
						商品赠送，免单！
						<el-button type="text" size="mini" @click="channelPush(items,tableKey)">取消赠送</el-button>
					</span>
					<template v-else>
						<span v-if="discount >= 1">
							<el-button type="text" size="mini" @click="ishow(items,tableKey)">改价优惠</el-button>
							<el-button type="text" size="mini" @click="isPush(items,tableKey)">赠送优惠</el-button>
						</span>
						<span v-else>
							<span class="input">
								<el-input type="text"
									size="medium"
									style="width:120px"
									placeholder="请输入金额"
									@blur="discountItem(items,1,$event)"
									@focus="clearVal($event)"
									v-model="discount_amount"
									oninput="this.value=(this.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null">
									<span style="line-height:36px" slot="suffix">元</span>
								</el-input>
							</span>
							<span style="display:inliin-block;width:80px">
								<img style="width:20px;text-align:center;line-height:50px" src="../../assets/image/goto.png">
							</span>
							<span style="display:inliin-block;width:140px">
								<el-input type="text"
									size="medium"
									style="width:120px"
									placeholder="请输入比例"
									@blur="discountItem(items,2,$event)"
									@focus="clearVal($event)" v-model="discount_rate"
									oninput="this.value=(this.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null;if(value>=100)value=100;if(value<=0.01)value=0.01">
									<span style="line-height:36px" slot="suffix">%</span>
								</el-input>
							</span>
							<el-button type="text" size="mini" @click="channelShow(items,tableKey)">取消</el-button>
						</span>
					</template>
					
				</div>
				<!-- 商品优惠结束 -->
			</template>
			
			<div class="goodCoupon">
				<span class="coupon1">销售员</span>
				<span>
					<el-select v-model="merchant_uid" placeholder="选择销售员" style="width:100%;" size="small">
						<el-option label="请选择" value="0">请选择</el-option>
						<el-option v-for="saleItem in salesManList" :key="saleItem.uid" :label="saleItem.realname" :value="saleItem.uid">
						</el-option>
					</el-select>
				</span>
			</div>
			<div class="goodCoupon" v-if="items.is_goods == false">
				<span class="coupon1">服务员</span>
				<span>
					<el-select v-model="waiter_uid" placeholder="选择服务员" style="width:100%">
						<el-option label="请选择" value="0">请选择</el-option>
						<el-option v-for="saleItem in salesManList" :key="saleItem.uid" :label="saleItem.realname" :value="saleItem.uid">
						</el-option>
					</el-select>
				</span>
			</div>
			<!-- 选择员工开始 -->
			<!-- 选择员工结束 -->
			<div class='btnSub'>
				<el-button size="small" @click="cancelItemUpdate(items,tableKey)">取消</el-button>
				<el-button type="primary" size="small" @click="updateProjectItem(items,tableKey)">确认</el-button>
			</div>
		</div>
		<div class="item" slot="reference" @click="handelListSelected(items,tableKey)" >
			<div class="leftImg">
				<i v-if="!use_lock" class="el-icon-d-arrow-left" style="color:#FF700B"></i>
			</div>
			<div class="item-right-main">
				<div class="item-right-main-top">
					<div class="top-goodsname">
						{{items.project_name}}
					</div>
					<div class="top-goodsclass">
						<el-tag v-for="(skuRow,index) in items.skuList" size="mini" :key="index" style="margin-right:2px;">{{skuRow}}</el-tag>
					</div>
					<div class="top-goodsnum" @click.stop="numberStop">
						<el-input-number size="mini" :min="1" :max="100" v-model="quantity" @change="onNumChange($event,items.cart_id)"
						 :precision="0" :disabled="!['goods','service'].includes(items.project_type)">
						</el-input-number>
					</div>
					<div class="top-goodsprice">{{itemTotal}}</div>
					<div class="top-goodsbutton">
						<el-button v-if="isShowDel" type="text" size="mini" @click.stop="onDelItem(items.cart_id)">删除</el-button>
					</div>
				</div>
				<div class="item-right-main-footer">
					<div class="main-footer-right">
						<div>销售员：
							<span v-for="(salesmanRow,index) in salesManList" :key="index">
								<span v-if="salesmanRow.uid == items.merchant_uid">
									{{salesmanRow.realname}}
								</span>
							</span>
						</div>
						<div v-if="items.is_goods == false">
							服务员：
							<span v-for="(salesmanRow,index) in salesManList" :key="index">
								<span v-if="salesmanRow.uid == items.waiter_uid">
									{{salesmanRow.realname}}
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-popover>
</template>

<script>
	import { calculate, calculateDiscount } from '@/api/common'
	import { debounce } from '@/common/js/util';
	import { isEmpty } from '@/common/js/util';
	module.exports = {
		// 组件名称, 在外部可以使用<delete-confirm-popover></delete-confirm-popover>来使用组件
		name: "pop-item",
		// 组件的属性, 可以从外部传入相应的值进来
		props: ["items", "salesManList", "itemsKey"],
		data: function() {
			return {
				visible: false,
				isNoUpDate:true,
				tableKey: 0,
				// loading:false,

				use_member_price: '0',
				use_user_card: '0',

				is_gifts: 0,
				discount: '1',

				discount_amount: '',
				discount_rate: '',

				merchant_uid: '0',
				waiter_uid: '0',

				quantity: '',

				app_member_price_discount_status: '',
				app_member_price_discount_value: 0,

				total_price: '',
				cart_id: '',
				quantity_switch: true,
				deposit_amount: 0,

			};
		},
		watch: {
		　　items: {
				handler(newValue, oldValue) {
					if(newValue != oldValue){
						this.initItemObj(newValue);
					}
			　　},
				deep: true,
				immediate: true,
			}
		},
		computed: {
			isShowDel(){
				return this.items.appointment_id > 0 ? false : true
			},
			use_lock(){
				return this.items.user_card_use_lock == 1 ? true : false
			},
			itemTotal() {
				let temp_price = calculate(this.items.project_original_price,'*', this.quantity);
				let temp_num = 0;
				if (isEmpty(temp_price) || temp_price === 0 || this.is_gifts == 1) {	
					this.items.sub_total_amount = 0;
					return 0;
				}
				if (this.use_user_card > 0 && this.items.user_card_use_lock != 1) {
					if (this.quantity > 1) {
						temp_price = calculate(temp_price, '-', this.items.project_original_price); 
					}else {
						this.items.sub_total_amount = 0;
						return 0;
					}
				}

				if (this.quantity_switch) {
					this.items.temp_total_amount = temp_price;
					return temp_price;
				}
				
				

				if (this.items.user_id > 0 && this.app_member_price_discount_status == '1' && this.use_member_price == '1') {
					const member_price_temp = calculate(this.app_member_price_discount_value, '*', (this.use_user_card > 0 ? this.quantity - 1 : this.quantity));
					temp_price = calculate(temp_price,'-', member_price_temp)
				}
				// 已付定金。
				if(this.deposit_amount > 0){
					temp_price  = calculate(temp_price,'-',this.deposit_amount)
					temp_num = Number(this.deposit_amount); 
				}
				this.total_price = temp_price;
				if (this.discount_amount != '') {
					temp_price = calculate(temp_price,'-',this.discount_amount);

					if (temp_price <= 0.01) {
						temp_price = 0.01
						if (parseFloat(this.discount_amount) >= calculate(this.total_price,'-',0.01)) {
							this.discount_amount = calculate(this.total_price,'-',0.01) ;
							this.discount_rate = 0.01;

						}
					}else{
						if(this.discount_amount>0 && (this.discount_rate >= 100 || this.discount_rate<=0.01)){
							this.discount_rate =  calculateDiscount(this.total_price,this.discount_amount,true);
						}
						if (this.discount_rate <= 0.01){
							this.discount_rate = 0.01;
						}
					}
					// temp_num += Number(this.discount_amount);
				}
	
				this.items.sub_total_amount = temp_price;
				return  calculate(temp_price, '+', temp_num);
			},
		},
		methods: {
			initItemObj(obj){
				this.use_user_card = obj.use_user_card;
				if (obj.use_user_card > 0 && obj.user_card_use_lock == 0) {
					const foundItem = obj.user_card_service.find(item => item.user_card_id === obj.use_user_card);
					if (!foundItem) {
						this.use_user_card = '0';
						this.$message.info('会员预付卡已使用或者已过期！');
					}
				}
				// console.log();
				this.use_member_price = obj.use_member_price || 1;
				this.deposit_amount = obj.deposit_amount;
				this.is_gifts = obj.is_gifts;
				this.discount = obj.discount;
				this.discount_amount = obj.discount_amount;
				this.discount_rate = obj.discount_rate;
				this.merchant_uid = obj.merchant_uid;
				this.waiter_uid = obj.waiter_uid;
				this.quantity = obj.quantity;
				this.cart_id = obj.cart_id;
				this.app_member_price_discount_status = obj.app_member_price.discount_status;

				if (this.items.user_id != '0') {
					// this.use_member_price = '1';

					if(this.items.member_discount_amount != 0){
						this.app_member_price_discount_value = this.items.member_discount_amount //calculate(this.quantity,'*',this.items.member_discount_amount);
					}else{
						if(this.items.app_member_price.discount_type == '1'){
							this.app_member_price_discount_value = calculate(1-this.items.app_member_price.discount,'*',this.items.project_original_price)
						}else{
							this.app_member_price_discount_value = parseFloat(this.items.app_member_price.discount_price);
						}
					}
				}
				this.total_price = parseFloat(this.items.project_subtotal_amount);
				this.quantity_switch = false;
			},
			numberStop() {
				//防止穿透
			},
			clearVal(ev) {
				ev.target.value = '';
			},
			discountItem(item,type,ev) {
				if (ev.target.value == '' || ev.target.value == '0' || (type == 2 && ev.target.value >= 100)) {
					ev.target.value = (type == 1) ? '0' : '100';
					this.discount_amount = '0'
					this.discount_rate = '100'
				}
				if (type == 1) {
					if (parseFloat(this.discount_amount) >= calculate(this.total_price,'-',0.01)) {
						this.discount_amount = calculate(this.total_price,'-',0.01);
						this.discount_rate = 0.01;
					} else {
						this.discount_rate = calculateDiscount(this.total_price,this.discount_amount,true);
						if (this.discount_rate <= 0.01){
							this.discount_rate = 0.01;
						}
					}
				} else {

					if (this.discount_rate <= 0.01) {
						this.discount_rate = 0.01;
						this.discount_amount = calculate(this.total_price,'-',0.01);
					}else{
						this.discount_amount =  calculateDiscount(this.total_price,this.discount_rate);

					}
				}

			},
			cardChange(e){
				if(e > 0){
					if (this.quantity == 1) {
						this.use_member_price = '0'
					}
					
					this.discount = 1;
					this.discount_amount = 0;
					this.discount_rate = 100;
					this.is_gifts = 0;
				}
			},
			ishow(item, key) {
				this.quantity_switch = false;
				this.discount = 0;
				this.discount_amount = 0;
				this.discount_rate = 100;
			},
			isPush(item, key) {
				this.quantity_switch = false;
				this.is_gifts = 1;
				this.discount = 1;
				this.discount_amount = 0;
				this.discount_rate = 100;
				this.use_member_price = '0';
			},
			channelPush(item, key) {
				this.is_gifts = 0;
				this.discount = 1;
				this.discount_amount = 0;
				this.discount_rate = 100;
			},
			hidPopover(){
				if(this.isNoUpDate){
					// this.initItemObj(this.items);
				}
			},
			channelShow(item, key) {
				this.discount = 1;
				this.discount_amount = 0;
				this.discount_rate = 100;
			},
			cancelItemUpdate(item, key) {

				this.visible = false;
			},
			updateProjectItem(item, key) {

				this.isNoUpDate = false
				this.visible = false;
				// var temp_total_price = calculate(this.items.project_retail_price,'*',this.items.quantity);
				// this.items.sub_total_amount
				let temp_total_price = this.items.sub_total_amount
				if(this.deposit_amount > 0){
					temp_total_price = calculate(temp_total_price,'+',this.deposit_amount)
				}
				const obj = {
					project_subtotal_amount	: temp_total_price,
					discount_amount			: this.discount_amount,
					cart_id					: this.cart_id,
					use_user_card			: this.use_user_card,
					use_member_price		: this.use_member_price,
					is_gifts				: this.is_gifts,
					merchant_uid			: this.merchant_uid,
					waiter_uid				: this.waiter_uid,
				};
				this.$emit('updateItem', obj, '');
			},
			handelListSelected(item, key) {
				// this.visible = !this.visible;
			},
			onNumChange(value, cart_id) {
					// this.items.quantity 	= value;
				this.visible = false
				
				// this.use_user_card 		= '0';
				// this.timeCount 			= 0
				// this.quantity_switch	= true;
				// this.discount 		 	= 1;
				// this.discount_amount 	= 0;
				// this.discount_rate	  	= 100;
				// this.use_member_price 	= '1';
				// this.is_gifts 			= 0;
				const upDateQuantity = () => {
					this.$emit('quantity', value, cart_id);
				}
				this.$emit('loading');
				debounce(upDateQuantity, 1000)()
			},
			onDelItem(cart_id) {
				this.$emit('del', cart_id, this.items );
			},
		}
	};
</script>
<style scoped>
	.item .leftImg {
		/* display: inline-block; */
		float: left;
		border-right: 1px solid #ffb37c;
		height: 130px;
		line-height: 129px;
		width: 5%;
	}

	.item .item-right-main {
		display: inline-block;
		/* width: 430px; */
		width: 94%;
		height: 129px;
	}

	.item-right-main .item-right-main-top {
		position: relative;
		height: 60%;
		border-bottom: 1px solid #ffb37c;
	}

	.item-right-main .item-right-main-top .top-goodsname {
		position: absolute;
		top: 0px;
		left: 5px;
		height: 50px;
		width: 40%;
		font-size: 12px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.item-right-main .item-right-main-top .top-goodsclass {
		position: absolute;
		bottom: 3px;
		left: 5px;
		height: 20px;
		width: 40%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.item-right-main .item-right-main-top .top-goodsnum {
		position: absolute;
		top: 5px;
		right: 110px;
		height: 50px;
		width: 120px;
		text-align: left;
	}

	.item-right-main .item-right-main-top .top-goodsnum .el-input-number {
		width: 100px;
	}

	.item-right-main .item-right-main-top .top-goodsprice {
		position: absolute;
		top: 5px;
		right: 40px;
		height: 50px;
		width: 80px;
		text-align: center;
	}

	.item-right-main .item-right-main-top .top-goodsbutton {
		position: absolute;
		top: 0;
		right: 0;
		height: 50px;
		width: 40px;
		text-align: center;
	}


	.item-right-main .item-right-main-footer {
		height: 40%;
	}

	.item-right-main .item-right-main-footer .main-footer-right {
		width: 50%;
		margin: 10px 5px;
	}

	.right-textarea {
		position: absolute;
		bottom: 85px;
		right: 0;
		width: 445px;
		z-index: 17;
	}

	.right-textarea .el-textarea .el-textarea__inner {
		border-radius: 0px;
	}



	/* 弹窗涉及样式 */
	.goods_info {
		position: relative;
		font-size: 12px;
		padding: 5px 5px;
		border: 1px solid rgb(93, 95, 99);
		height: 70px;
	}

	.goods_info .goods_name {
		padding: 5px 10px;
		position: absolute;
		top: 0;
		left: 0;
		width: 48%;
		height: 28px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.goods_info .goods_class {
		padding-left: 10px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 25px;
	}

	.goods_info .goods_price {
		padding: 5px 10px;
		position: absolute;
		top: 0px;
		right: 110px;
		height: 50px;
		width: 130px;
		text-align: center;
	}

	.goods_info .goods_total_price {
		padding: 5px 10px;
		position: absolute;
		top: 0;
		right: 0;
		height: 50px;
		width: 100px;
		text-align: center;
	}

	.selWarpper {
		margin-top: 30px
	}

	.selWarpper .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #DCDFE6;
		background-color: #fffaf7;
	}

	.selWarpper .el-select .el-input__inner:focus {
		border: 1px solid #DCDFE6;
	}

	.goodCoupon {
		width: 99.5%;
		border: 1px solid #C0C4CC;
		height: 50px;
		line-height: 50px;
		margin-top: -1px;
	}

	.goodCoupon>span {
		display: inline-block;
	}

	.goodCoupon .coupon1 {
		padding: 0 30px 0 16px;
		color: #c0c4cc;
	}

	.goodCoupon .input {
		display: inline-block;
		width: 120px
	}

	.btnSub {
		margin: 10px;
		height: 30px;
		text-align: right;
	}
</style>



// WEBPACK FOOTER //
// popItem.vue?74a062ca